import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl } from '@grandvisionhq/state';
import { timeSelectionOtherDayEvent, timeSelectionNewHourOtherDayEvent, timeSelectionNewHourSameDayEvent } from '../../data-layer/actions.js';
import { useAppointmentDurationLabel } from '../../hooks/use-appointment-duration-label.js';
import useDataLayerInput from '../../hooks/use-data-layer-input.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import { replaceTimeSlotQueryParameters } from '../../utils/replace-time-slot-query-parameters.js';
import AppointmentPickDifferentTimeSlot from './AppointmentPickDifferentTimeSlot.js';

const AppointmentPickDifferentTimeSlotContainer = ({ onSelectTimeSlot: emitSelectTimeSlot , selectedTimeSlot , timeSlots , loading  })=>{
    const [{ setTimeSlot  }, { timeSlot: timeSlot1 , type  }] = useAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext();
    const { getFormattedLabel , getLabel , dateTime: { formatDate  } ,  } = useIntl();
    const dataLayerInput = useDataLayerInput();
    const durationLabel = useAppointmentDurationLabel(type);
    const labels = React.useMemo(()=>({
            loading: getLabel('appointments.component.appointmentPickDifferentTimeSlot.loading'),
            noTimesAvailableOn: getFormattedLabel('appointments.component.appointmentPickDifferentTimeSlot.noTimesAvailableOn', {
                labelData: {
                    date: timeSlot1 ? `${formatDate(timeSlot1.from, 'long')}` : ''
                }
            }),
            noTimesSelectAnotherDay: getLabel('appointments.component.appointmentPickDifferentTimeSlot.noTimesSelectAnotherDay'),
            selectAnotherDay: getLabel('appointments.component.appointmentPickDifferentTimeSlot.selectAnotherDay'),
            selectATime: getLabel('appointments.component.appointmentPickDifferentTimeSlot.selectATime'),
            selectATimeSubtitle: durationLabel ? getFormattedLabel('appointments.component.appointmentPickDifferentTimeSlot.selectATimeSubtitle', {
                labelData: {
                    duration: durationLabel
                }
            }) : ''
        })
    , [
        durationLabel,
        formatDate,
        getFormattedLabel,
        getLabel,
        timeSlot1
    ]);
    const onClickPrevious = React.useCallback(()=>{
        const { typeId , storeId , search , userLocation  } = queryParams;
        const dataLayerEvent = timeSlots.length === 0 ? timeSelectionOtherDayEvent(dataLayerInput) : timeSelectionNewHourOtherDayEvent(dataLayerInput);
        DataLayer.pushEvent(dataLayerEvent);
        goTo('when', {
            typeId,
            storeId,
            search,
            userLocation
        });
    }, [
        dataLayerInput,
        goTo,
        queryParams,
        timeSlots.length
    ]);
    const onSelectTimeSlot = React.useCallback((timeSlot)=>{
        replaceTimeSlotQueryParameters(timeSlot);
        setTimeSlot(timeSlot);
        emitSelectTimeSlot(timeSlot);
        const dataLayerEvent = timeSelectionNewHourSameDayEvent(dataLayerInput);
        DataLayer.pushEvent(dataLayerEvent);
    }, [
        setTimeSlot,
        emitSelectTimeSlot,
        dataLayerInput
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentPickDifferentTimeSlot, {
        selected: selectedTimeSlot,
        labels: labels,
        loading: loading,
        timeSlots: timeSlots,
        onSelectTimeSlot: onSelectTimeSlot,
        onClickPrevious: onClickPrevious
    });
};

export { AppointmentPickDifferentTimeSlotContainer as default };
//# sourceMappingURL=AppointmentPickDifferentTimeSlotContainer.js.map
